import { Component, OnInit } from '@angular/core';
import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {DatePipe} from '@angular/common';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-editar-cadastro',
  templateUrl: './editar-cadastro.component.html',
  styleUrls: ['./editar-cadastro.component.css'],
  providers: [DatePipe]
})
export class EditarCadastroComponent implements OnInit {



  model: NgbDateStruct | any;
  avatar: any =  '../../assets/img/avatar.jpg';
  usuarios: any = '';
  url: any;
  // tslint:disable-next-line:max-line-length
  editarConta: any = {id: '', name: '', nascimento: 'hhhh', email: '', role: 'User', avatar: '',
    namecorreto: '', telefone: '', nacionalidade: '', sexo: 'm', cep: '', cpf: '', estado: '1'
    , cidade: '', cpf_pj: '', nomeFatasia: '', segmento: 1
  };
  cidades: any;
  erro: any = 0;
  segmentos: any;
  user: any = [];
  // tslint:disable-next-line:variable-name
  dado_estados: any ;
  private person: any;
  constructor(private route: ActivatedRoute, private http: HttpClient, private datePipe: DatePipe, private router: Router) { }

  // tslint:disable-next-line:typedef
  ngOnInit(): void {
    this.getsegmentos().subscribe(seg => {
      this.segmentos = seg;
      // tslint:disable-next-line:triple-equals
    });
    this.getusuariodados().subscribe( async user => {
      this.user = user;
      // @ts-ignore
      this.editarConta = JSON.parse(  localStorage.getItem('editar_conta_dados')) ;
      this.editarConta.nascimento = this.datePipe.transform(this.editarConta.nascimento, 'dd/MM/yyyy');
      this.url = environment.url;
      // this.editarConta.avatar =  this.url +  this.editarConta.avatar;
      console.log(this.editarConta);
      if (this.editarConta.avatar === '' || this.editarConta.avatar === 'avatar.jpg') {
        this.avatar = this.url + 'api/app/img/avatar.jpg';
      } else {
        this.avatar = this.url + 'api/app/img/' + this.editarConta.avatar;
      }
      this.getcidade().subscribe(cidade => {
        this.cidades = cidade;
        // tslint:disable-next-line:triple-equals


      });



      this.getestados().subscribe(estados => {
        this.dado_estados = estados;
        // tslint:disable-next-line:triple-equals


      });
      this.editarConta.cidade =  this.editarConta.cidade;
    });
    // tslint:disable-next-line:triple-equals
  }
  parseDate(dateString: string): Date | null {
    if (dateString) {
      return new Date(dateString);
    }
    return null;
  }


  // tslint:disable-next-line:typedef
  onSelectFile( event: any )  {
    this.readThis(event.target);
  }

  readThis(inputValue: any): void {
    const file: File = inputValue.files[0];
    const myReader: FileReader = new FileReader();

    myReader.onloadend = (e) => {
      this.avatar = myReader.result;
      this.editarConta.avatar = myReader.result;
    };
    myReader.readAsDataURL(file);
    console.log(this.editarConta);

  }
  // // tslint:disable-next-line:typedef
  // onSelectFile(event: any) {
  //   if (event.target.files && event.target.files[0]) {
  //     const reader = new FileReader();
  //
  //     reader.onload = (ev: any) => {
  //       this.editarConta.avatar = ev.target.result;
  //     };
  //    // reader.readAsDataURL(event.target.files[0]);

  //   }
  // }

  // tslint:disable-next-line:typedef
  getcidade(){
    return this.http.get(`${environment.api}/app/cidades/` + this.editarConta.estado );
  }

  // tslint:disable-next-line:typedef
  postavatar(){
    return this.http.post(`${environment.api}/cadastros/avatar` , this.editarConta );
  }
  // tslint:disable-next-line:typedef
  getuser(){
    return this.http.get(`${environment.api}/cadastros/editar/` + this.editarConta.estado );
  }
  // tslint:disable-next-line:typedef
  getestados(){
    return this.http.get(`${environment.api}/estados` );
  }
  // tslint:disable-next-line:typedef
  onAddCidade(){
    this.getcidade().subscribe(cidade => {
      this.cidades = cidade;
      // tslint:disable-next-line:triple-equals
      console.log(this.editarConta);

    });

  }

  // tslint:disable-next-line:typedef
  atualizarConta(){
    this.enviarDadosConta().subscribe(dadosconta => {
      console.log(dadosconta);
      // tslint:disable-next-line:triple-equals
      if ( dadosconta == 0){
        this.erro = 1;
      }else{
        this.erro = 0;
        this.router.navigate(['cadastros']);
      }
      // tslint:disable-next-line:triple-equals
    });
  }
  // tslint:disable-next-line:typedef
  enviarDadosConta(){

    // tslint:disable-next-line:max-line-length
    return this.http.post(`${environment.api}/cadastros/update/` + this.editarConta.id, this.editarConta);
  }
  // tslint:disable-next-line:typedef
  getusuariodados(){
    return this.http.get(`${environment.api}/user`);
  }
  // tslint:disable-next-line:typedef
  getsegmentos(){
    return this.http.get(`${environment.api}/segmentos` );
  }

}
